import mock from './MockConfig';
// import './apis';

mock.onAny().passThrough();
